import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { useHandleShare } from '@/hooks/useHeaderActions';
import { getUserFavorites } from '@/redux/selectors/favorites';
import {
  getListingData,
  getListingDescription,
  getListingTitle,
} from '@/redux/selectors/listing/page';

import ListingGalleryHeader from './ListingGalleryHeader';

const GalleryHeaderContainer: React.FC = () => {
  const listing = useSelector(getListingData);
  const favorites = useSelector(getUserFavorites);
  const isFavorite = favorites?.rentals.some(f => f.item_id === listing?.id);
  const description = useSelector(getListingDescription);
  const title = useSelector(getListingTitle);

  const [isShareOpen, setIsShareOpen] = useState(false);
  const handleShare = useHandleShare(description, title, isShareOpen, setIsShareOpen, () => {});

  return (
    <ListingGalleryHeader
      listingData={listing ?? undefined}
      isFavorite={isFavorite}
      handleShare={handleShare}
    />
  );
};

export default GalleryHeaderContainer;
